<template>
  <div class="main-container">
    <pgg-navbar />
    <app-main class="app-container" />
    <!-- <pgg-footer /> -->
  </div>
</template>

<script>
import AppMain from './components/AppMain'
import PggNavbar from './components/PggNavbar'
// import PggFooter from './components/PggFooter'

export default {
  components: {
    AppMain,
    PggNavbar
    // PggFooter
  }
}
</script>

<style lang="scss" scoped>
  .app-container {
    margin-top: 56px;
  }
  .main-container {
    overflow: scroll;
    min-width: 1200px;
  }
</style>
